import React from "react";
import "./carousel.styles.css";
// import Slide1 from "../../images/carousel/key.jpg";


const MyCarousel = () => {
  return (
    <div id="home" className="slider-size">
      
    </div>
  );
};

export default MyCarousel;
